// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"dcc61dc2","325":"3571e810","788":"fa3c4d80"}[chunkId] + ".chunk.css";
};